import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { Descriptions, Breadcrumb, Space } from 'antd';
import {
  Link,
  EmailAddress,
  SanitizedHTML,
  DateDisplay,
} from 'components/layout';

import { GET_EMAIL_LOG_DETAIL } from 'gql/emailLogs';
import { getEmailAddressTitleForRecipient } from 'utils';
import { LinkToProject } from 'components/routing/link';

const EmailLog = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_EMAIL_LOG_DETAIL, {
    variables: { ids: [id] },
  });

  const emailLog = data?.emailLogs[0];
  return (
    <PageContainer
      loading={loading}
      header={{
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/email-logs">Email Logs</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{id}</Breadcrumb.Item>
          </Breadcrumb>
        ),
        title: 'Email Log Detail',
      }}
    >
      <Descriptions column={2}>
        <Descriptions.Item label="Email Log ID">
          {emailLog?.id}
        </Descriptions.Item>
        <Descriptions.Item label="Project Title">
          {emailLog?.project ? (
            <LinkToProject projectId={emailLog?.project?.id}>
              {emailLog?.project?.title}
            </LinkToProject>
          ) : (
            emailLog?.projectApplication?.title
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Email ID">
          {emailLog?.emailTemplate.emailId}
        </Descriptions.Item>
        <Descriptions.Item label="Subject">
          {emailLog?.emailTemplate.subject}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          <DateDisplay date={emailLog?.createdAt} format="YYYY-MM-DD hh:mm" />
        </Descriptions.Item>
        <Descriptions.Item label="Send At">
          <DateDisplay date={emailLog?.updatedAt} format="YYYY-MM-DD hh:mm" />
        </Descriptions.Item>
        <Descriptions.Item label="Status">{emailLog?.status}</Descriptions.Item>
        <Descriptions.Item label="Sender">
          {`${emailLog?.emailTemplate?.senderEmail} [${emailLog?.emailTemplate?.senderName}]`}
        </Descriptions.Item>
        {emailLog?.errorMessage ? (
          <Descriptions.Item label="Error Message">
            {emailLog?.errorMessage}
          </Descriptions.Item>
        ) : null}
        <Descriptions.Item label="To" span={2}>
          <Space split=",">
            {emailLog?.to?.map((item) => {
              const title = getEmailAddressTitleForRecipient(item);
              return (
                <EmailAddress
                  key={item.id}
                  netId={item.user.netId}
                  email={item.user.email}
                  title={title}
                />
              );
            })}
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="Cc" span={2}>
          <Space split=",">
            {emailLog?.cc?.map((item) => {
              const title = getEmailAddressTitleForRecipient(item);
              return (
                <EmailAddress
                  key={item.id}
                  netId={item.user.netId}
                  email={item.user.email}
                  title={title}
                />
              );
            })}
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="Email Body" span={2}>
          <SanitizedHTML dirty={emailLog?.emailBody} />
        </Descriptions.Item>
      </Descriptions>
    </PageContainer>
  );
};

export default EmailLog;
